export default __webpack_public_path__ + "static/media/rika_xl.8f1bbe61.jpg";